import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../utils/IDS";
import { GET, POST } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import Cookies from "js-cookie";

// Auth - Login
export const AuthLogin = createAsyncThunk(
  "auth/admin-login",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth, data);
      if (res.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

// GET Auth - Login
export const GETAuthLogin = createAsyncThunk(
  "auth/login/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Auth);
      console.log(res, "res res ttttttttttt");

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const dashboard = createAsyncThunk(
  "dashbord/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Dashboard);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const AuthLogOut = createAsyncThunk(
  // Auth - Logout
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      // const res = await POST(APIS.LogOut);
      // const res = await GET(APIS.Auth);
      Cookies.remove("ultimate_analytics_admin_security", { path: "/" });
      return {
        data: {},
        token: null,
        code: null,
        role: null,
        permissions: null,
        isLogin: false,
        error: null,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

// export const checkTokenValidity = createAsyncThunk(
//   "auth/checkTokenValidity",
//   async (_, { rejectWithValue }) => {
//     const token = Cookies.get("ultimate_analytics_admin_security");
//     if (!token) {
//       return rejectWithValue("No token found");
//     }

//     try {
//       const decodedToken = JSON.parse(atob(token.split(".")[1]));
//       const currentTime = Date.now() / 1000;
//       // Check expiry
//       if (decodedToken.exp < currentTime) {
//         Cookies.remove("ultimate_analytics_admin_security", { path: "/" });
//         return rejectWithValue("Token expired");
//       }

//       return decodedToken;
//     } catch (error) {
//       return rejectWithValue(error.message || "Token validation failed");
//     }
//   },
// );

export const checkTokenValidity = createAsyncThunk(
  "auth/checkTokenValidity",
  async (_, { rejectWithValue }) => {
    const token = Cookies.get("ultimate_analytics_admin_security");

    if (!token) {
      return rejectWithValue("No token");
    }

    try {
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        Cookies.remove("ultimate_analytics_admin_security", { path: "/" });
        return rejectWithValue("Token expired");
      }

      return decodedToken;
    } catch (error) {
      return rejectWithValue("Token invalid");
    }
  },
);

export const Slice = createSlice({
  name: "auth",
  initialState: {
    data: {},
    token: null,
    code: null,
    activetoken: null,
    id: null,
    role: null,
    role_id: null,
    unique_id: null,
    name: null,
    permissions: null,
    isLogin: false,
    status: IDS.SLICESTATUS.Idle,
    error: null,
    all_permission: {},
    all_dashboard: {},
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(AuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload.data.token;
        state.activetoken = action.payload.data.active_token;
        state.role = action.payload.data.role;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(AuthLogin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })
      .addCase(GETAuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETAuthLogin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
        state.id = action.payload.data.id;
        state.role = action.payload.data.role;
        state.role_id = action.payload.data.role_id;
        state.code = null;
        state.unique_id = action.payload.data.unique_id;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(GETAuthLogin.rejected, (state, action) => {
        console.log(action, "GETAuthLogin action action action action ");

        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        // state.isLogin = false;
        state.data = {};
        state.token = null;
        state.code = action.payload.code;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      //
      .addCase(AuthLogOut.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogOut.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = {};
        state.token = null;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      .addCase(AuthLogOut.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(dashboard.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(dashboard.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_dashboard = action.payload?.data;
      })
      .addCase(dashboard.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(checkTokenValidity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(checkTokenValidity.fulfilled, (state, action) => {
        console.log(action.payload, "action.payload checktokan");

        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload.token;
        state.activetoken = action.payload.active_token;
        // state.role = action.payload.data.role;
        state.isLogin = true;
      })
      .addCase(checkTokenValidity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
